import Image from "next/image";

function PhoneFrame({ steps, activeId }) {
  return (
    <figure className="phone-frame">
      {steps.map((step) => (
        <div
          key={step.id}
          className={`${
            activeId === step.id ? "opacity-100" : "opacity-0"
          } transition-opacity duration-500 ease-in-out`}
        >
          <Image src={step.img} width={300} height={300} alt={step.title} />
        </div>
      ))}
    </figure>
  );
}

export default PhoneFrame;
